
window.ajax_cart = "normal";
window.money_format = "";
window.shop_currency = "";
window.show_multiple_currencies = false;
window.use_color_swatch = true;
window.color_swatch_style = "normal";
window.enable_sidebar_multiple_choice = false;
window.file_url = "//cdn.shopify.com/s/files/1/0173/7644/4470/files/?185955";
window.asset_url = "";
window.inventory_text = {
    in_stock: "In stock",
    many_in_stock: "Many in stock",
    out_of_stock: "Out of stock",
    add_to_cart: "Add to Cart",
    add_all_to_cart: "Add all to Cart",
    sold_out: "Sold Out",
    select_options : "Select options",
    unavailable: "Sold Out",
    no_more_product: "No more product",
    show_options: "Show Variants",
    hide_options: "Hide Variants",
    adding : "Adding",
    thank_you : "Thank You",
    add_more : "Add More",
    cart_feedback : "Added",
    add_wishlist : "Add to Wish List",
    remove_wishlist : "Remove Wish List",
    previous: "Prev",
    next: "Next"
};
window.multi_lang = false;
window.infinity_scroll_feature = true;
window.newsletter_popup = false;  
window.pincode_popup = false;



var category = ["FOODS", "PERSONAL CARE", "STATIONERY", "MATCHES AND AGARBATTI", "SHOP ALL"];
var sub_category = ["BISCUITS & CAKES", "NOODLES & PASTA", "STAPLES", "SNACKS", "BEVERAGES","DAIRY", "CONFECTIONERY", "CHOCOLATES", "HANDWASH", "FLOOR CLEANER", "BODY OIL", "SHOWER GEL", "ANTISEPTIC", "SOAPS", "FRAGRANCE", "ESSENTIAL OIL", "SKIN CARE", "READY TO EAT", "BINGO", "AASHIRVAAD INSTANT MIXES", "ANTISEPTIC LIQUID","SAVLON HANDWASH", "FROZEN FOOD","SUNFEAST BISCUITS & CAKES"];
var category_hierarchy = [
	{
		"brand_name": "Sunfeast Marie Light",
		"sub_category": "Biscuits & Cakes",
		"category":"Foods"
	},
	{
		"brand_name": "Sunfeast Dark Fantasy",
		"sub_category": "Biscuits & Cakes",
		"category":"Foods"
	},
	{
		"brand_name": "",
		"sub_category": "Frozen Food",
		"category":"Foods"
	},
	{
		"brand_name": "Sunfeast Snacky",
		"sub_category": "Biscuits & Cakes",
		"category":"Foods"
	},
	{
		"brand_name": "Sunfeast Mom's Magic",
		"sub_category": "Biscuits & Cakes",
		"category":"Foods"
	},
	{
		"brand_name": "Sunfeast Moms Magic",
		"sub_category": "Biscuits & Cakes",
		"category":"Foods"
	},
	{
		"brand_name": "Sunfeast Bounce",
		"sub_category": "Biscuits & Cakes",
		"category":"Foods"
	},
	{
		"brand_name": "Sunfeast Farmlite",
		"sub_category": "Biscuits & Cakes",
		"category":"Foods"
	},
  {
		"brand_name": "Farmlite",
		"sub_category": "Biscuits & Cakes",
		"category":"Foods"
	},
	{
		"brand_name": "Sunfeast Milk Biscuit",
		"sub_category": "Biscuits & Cakes",
		"category":"Foods"
	},
	{
		"brand_name": "Sunfeast YiPPee! Pasta",
		"sub_category": "Noodles & Pasta",
		"category":"Foods"
	},
	{
		"brand_name": "Sunfeast YiPPee! Noodles",
		"sub_category": "Noodles & Pasta",
		"category":"Foods"
	},
  	{
		"brand_name": "B Naturals",
		"sub_category": "Beverages",
		"category":"Foods"
	},
	{
		"brand_name": "Aashirvaad Atta",
		"sub_category": "Staples",
		"category":"Foods"
	},
	{
		"brand_name": "Aashirvaad",
		"sub_category": "Staples",
		"category":"Foods"
	},
	{
		"brand_name": "Aashirvaad Spices",
		"sub_category": "Staples",
		"category":"Foods"
	},
	{
		"brand_name": "Aashirvaad Iodised Salt",
		"sub_category": "Staples",
		"category":"Foods"
	},
	{
		"brand_name": "ITC Master Chef Blended Spices",
		"sub_category": "Staples",
		"category":"Foods"
	},
	{
		"brand_name": "Bingo! Starters",
		"sub_category": "Snacks",
		"category":"Foods"
	},
	{
		"brand_name": "Bingo Mad Angles",
		"sub_category": "Snacks",
		"category":"Foods"
	},
	{
		"brand_name": "Bingo! Mad Angles",
		"sub_category": "Snacks",
		"category":"Foods"
	},
  	{
		"brand_name": "Bingo No Rulz",
		"sub_category": "Snacks",
		"category":"Foods"
	},
  	{
		"brand_name": "Bingo! No Rulz",
		"sub_category": "Snacks",
		"category":"Foods"
	},
	{
		"brand_name": "Bingo Original Style",
		"sub_category": "Snacks",
		"category":"Foods"
	},
	{
		"brand_name": "Bingo! Original Style",
		"sub_category": "Snacks",
		"category":"Foods"
	},
	{
		"brand_name": "Bingo Potato Chips",
		"sub_category": "Snacks",
		"category":"Foods"
	},
	{
		"brand_name": "Bingo! Potato Chips",
		"sub_category": "Snacks",
		"category":"Foods"
	},
	{
		"brand_name": "Bingo Tedhe Medhe",
		"sub_category": "Snacks",
		"category":"Foods"
	},
	{
		"brand_name": "Bingo! Tedhe Medhe",
		"sub_category": "Snacks",
		"category":"Foods"
	},
	{
		"brand_name": "Sunfeast B Natural Juices",
		"sub_category": "Beverages",
		"category":"Foods"
	},
	{
		"brand_name": "B Natural",
		"sub_category": "Beverages",
		"category":"Foods"
	},
	{
		"brand_name": "Gourmet Sunbean Coffee",
		"sub_category": "Beverages",
		"category":"Foods"
	},
	{
		"brand_name": "Sunfeast Wonderz Milk",
		"sub_category": "Beverages",
		"category":"Foods"
	},
	{
		"brand_name": "Aashirvaad Swasti Ghee",
		"sub_category": "Dairy",
		"category":"Foods"
	},
	{
		"brand_name": "Aashirvaad Svasti Ghee",
		"sub_category": "Dairy",
		"category":"Foods"
	},
	{
		"brand_name": "Aashirvaad Instant Mix",
		"sub_category": "Dairy",
		"category":"Foods"
	},
	{
		"brand_name": "Kitchens Of India",
		"sub_category": "Ready To Eat",
		"category":"Foods"
	},
	{
		"brand_name": "Jelimals",
		"sub_category": "Confectionery",
		"category":"Foods"
	},
	{
		"brand_name": "Candyman Fantastik",
		"sub_category": "Confectionery",
		"category":"Foods"
	},
	{
		"brand_name": "Candyman Choco Double Eclairs",
		"sub_category": "Confectionery",
		"category":"Foods"
	},
	{
		"brand_name": "Candyman Tadka Time",
		"sub_category": "Confectionery",
		"category":"Foods"
	},
	{
		"brand_name": "Fabelle Premium Chocolate",
		"sub_category": "Chocolates",
		"category":"Foods"
	},
	{
		"brand_name": "Fabelle Luxury Chocolates",
		"sub_category": "Chocolates",
		"category":"Foods"
	},
	{
		"brand_name": "Fabelle Premium Chocolate Bars",
		"sub_category": "Chocolates",
		"category":"Foods"
	},
	{
		"brand_name": "Fabelle Luxury Chocolates Bars",
		"sub_category": "Chocolates",
		"category":"Foods"
	},
	{
		"brand_name": "Aashirvaad Instant Mixes",
		"sub_category": "",
		"category":"Foods"
	},
	{
		"brand_name": "ITC Master Chef Frozen Prawns",
		"sub_category": "Frozen Foods",
		"category":"Foods"
	},
	{
		"brand_name": "ITC Master Chef Frozen Snacks",
		"sub_category": "Frozen Foods",
		"category":"Foods"
	},
	{
		"brand_name": "Savlon (Handwash)",
		"sub_category": "Handwash",
		"category":"Personal Care"
	},
	{
		"brand_name": "Savlon",
		"sub_category": "Savlon Handwash",
		"category":"Personal Care"
	},
	{
		"brand_name": "Fiama (Handwash)",
		"sub_category": "Handwash",
		"category":"Personal Care"
	},
	{
		"brand_name": "Nimyle",
		"sub_category": "Floor Cleaner",
		"category":"Personal Care"
	},
	{
		"brand_name": "Fiama (Body Oil)",
		"sub_category": "Body Oil",
		"category":"Personal Care"
	},
	{
		"brand_name": "Vivel (Shower Gel)",
		"sub_category": "Shower Gel",
		"category":"Personal Care"
	},
	{
		"brand_name": "Fiama (Shower Gel)",
		"sub_category": "Shower Gel",
		"category":"Personal Care"
	},
	{
		"brand_name": "Savlon (Antiseptic)",
		"sub_category": "Antiseptic",
		"category":"Personal Care"
	},
	{
		"brand_name": "Charmis",
		"sub_category": "Skin Care",
		"category":"Personal Care"
	},
	{
		"brand_name": "Dermafique",
		"sub_category": "Skin Care",
		"category":"Personal Care"

	},
	{
		"brand_name": "Savlon (Soap)",
		"sub_category": "Soaps",
		"category":"Personal Care"
	},
	{
		"brand_name": "Savlon",
		"sub_category": "",
		"category":"Personal Care"
	},
	{
		"brand_name": "Fiama (Soap)",
		"sub_category": "Soaps",
		"category":"Personal Care"
	},
	{
		"brand_name": "Vivel (Soap)",
		"sub_category": "Soaps",
		"category":"Personal Care"
	},
	{
		"brand_name": "Vivel",
		"sub_category": "",
		"category":"Personal Care"
	},
	{
		"brand_name": "Essenza Di Wills (Soap)",
		"sub_category": "Soaps",
		"category":"Personal Care"
	},
	{
		"brand_name": "Essenza Di Wills",
		"sub_category": "",
		"category":"Personal Care"
	},
	{
		"brand_name": "Engage",
		"sub_category": "Fragrance",
		"category":"Personal Care"
	},
	{
		"brand_name": "Essenza Di Wills (Fragrance)",
		"sub_category": "Fragrance",
		"category":"Personal Care"
	},
	{
		"brand_name": "Fiama (Essential Oil)",
		"sub_category": "Essential Oil",
		"category":"Personal Care"
	},
	{
		"brand_name": "Fiama",
		"sub_category": "",
		"category":"Personal Care"
	},
	{
		"brand_name": "Classmate",
		"sub_category": "",
		"category":"Stationery"
	},
	{
		"brand_name": "Paperkraft",
		"sub_category": "",
		"category":"Stationery"
	},
	{
		"brand_name": "Homelites",
		"sub_category": "",
		"category":"Matches & Agarbatti"
	},
	{
		"brand_name": "Mangaldeep",
		"sub_category": "",
		"category":"Matches & Agarbatti"
	},
];


var dataLayer = window.dataLayer = window.dataLayer || [];
var digitalData = window.digitalData = window.digitalData || [];
var getCartProduct;
var getProductFromHandle;
var setValueDataLayer;

$(function() {
    console.log( "BI01 - Adobe DataLayer Ready!" );
    //get cart product
    getCartProduct = function(){
        var cart_json = '';
        $.ajax({
            type: "get",
            url: '/cart.json',
            dataType: "json",
            async: false,
            cache: false,
            beforeSend: function() {
            },
            success: function(res) {
                cart_json = res;
            },
            error: function (xhr) {
            },
            complete: function () {
            }
        });

        return cart_json;
    }

    //get product from handle
    getProductFromHandle = function(product_handle){
        var product_json = '';
        // console.log('https://itcstore.in/products/'+product_handle+'.json')
        $.ajax({
            type: "get",
            url: 'https://itcstore.in/products/'+product_handle+'.json',
            dataType: "json",
            async: false,
            cache: false,
            beforeSend: function() {
            },
            success: function(res) {
                product_json = res;
            },
            error: function (xhr) {
            },

            complete: function () {
            }
        });

        return product_json;
    }
    
    if (product_compare_price == "" || product_compare_price == 0) {
        product_compare_price = product_price;
    }
    
    // Product Compare Price
    var discount = discount_calulcation(product_compare_price, product_price);
    var product_availability = "In Stock";
  
    //  Customer Login or not
    if (customer_email == ""){
        var customer_login = "Not Logged In";        // Logged In / Not Logged In
    } else {
        var customer_login = "Logged In";        // Logged In / Not Logged In
    }
    // Assignment Values as per the Homepage, Collections, Products, Cart and Static Pages
    switch(template_name) {
    case "index":
        page_type = "Homepage";
        page_name = "Homepage";
        break;
    case "collection":
        var category_found = category.indexOf(collcetion_title.toUpperCase());
        if (category_found >= 0){
            event_page = "ITCStore_CategoryView";
            page_type = "Category Page";
            category_name = collection_name;            
        } else {
            var sub_category_found = sub_category.indexOf(collcetion_title.toUpperCase());
                event_page = "ITCStore_SubCategoryView";
                page_type = "Sub Category Page";
                sub_category_name = collcetion_title;
                $.each(category_hierarchy, function(key, value){
                    // console.log("Data :", sub_category_name, value.sub_category.toUpperCase());
                    if (value.sub_category.toUpperCase() === collcetion_title.toUpperCase()){
                        category_name = value.category;
                        // brand_name = value.brand_name;
                        return (value.sub_category.toUpperCase() !== collcetion_title.toUpperCase());
                    }
                });
        }
        break;
    case "page":
        page_type = "Static Page";
        page_name = page_title;
        $.each(category_hierarchy, function(key, value){
            if (value.brand_name.toUpperCase() === page_title.toUpperCase()){
                page_type = "Brand Page";
                category_name = value.category;
                sub_category_name = value.sub_category;
                event_page = "ITCStore_BrandView";
                brand_name = page_title;
                if (page_title == "Savlon (Antiseptic)" || page_title == "Savlon (Soap)" || page_title == "Savlon (Handwash)" ){
                    brand_name = "Savlon";
                }
                if (page_title == "Essenza Di Wills (Fragrance)" || page_title == "Essenza Di Wills (Soap)"){
                    brand_name = "Essenza Di Wills";
                }
                if (page_title == "Vivel (Soap)" || page_title == "Vivel (Shower Gel)"){
                    brand_name = "Vivel";
                }
                if (page_title == "Fiama (Soap)" || page_title == "Fiama (Body Oil)" || page_title == "Fiama (Essential Oil)" || page_title == "Fiama (Handwash)" || page_title == "Fiama (Shower Gel)"){
                    brand_name = "Fiama";
                }
                return (value.brand_name.toUpperCase() !== page_title.toUpperCase());
            }
        });
        break;
    case "product":
        event_page = "ITCStore_ProductView";
        console.log("BI01 -product_available", product_available)
        if(product_available){
            product_availability = "In Stock"
        } else{
            product_availability = "Out of Stock"
        }
        page_type = "Product Page";
        abc = product_brand.toUpperCase();
        $.each(category_hierarchy, function(key, value){
            if (value.brand_name.toUpperCase() === product_brand.toUpperCase()){
                category_name = value.category;
                sub_category_name = value.sub_category;
                brand_name = product_brand;
                return (value.brand_name.toUpperCase() !== product_brand.toUpperCase());
            }
        });
        break;
    case "cart":
        event_page = "ITCStore_ProceedToCheckout";
        page_type = "Cart Page";

        break;
    case "login":
        event_page = "ITCStore_CustomerLogin";
        page_type = "Customer Login Page";
        break;
    case "account":
        event_page = "ITCStore_CustomerAccount";
        page_type = "Customer Account Page";
        break;
    case "404":
        page_type = "Error Page";
        break;
    default:
        // code block
    }
    var datalayer_json = {
        page: {
            PageType        :   page_type,
            PageName        :   page_name,
            Event           :   event_page,
            Category        :   category_name,
            SubCategory     :   sub_category_name,
            BrandName       :   brand_name
        },
        product: {
            ProductName     :   product_name,
            Sku             :   product_sku,
            Original_Price  :   product_compare_price,
            Offer_Price     :   product_price,
            Discount        :   discount,
            Category        :   category_name,
            SubCategory     :   sub_category_name,
            BrandName       :   brand_name,
            Availability    :   product_availability
        },
        user: {
            CustomerID: customer_id,
            CustomerLogin: customer_login,
            CustomerEmail: customer_email,
            Pincode: entered_pincode
        }
    };

    if (template_name == 'cart') {
        datalayer_json.product = getCartProductFormat();
    }

    dataLayer.push(datalayer_json);
    digitalData.push(datalayer_json);
    console.log("BI01 - Digial Data Layer: ", digitalData);
    // console.log('Data Layer: ',dataLayer);

    function getCartProductFormat(){
        var cart_product = getCartProduct();
        var temp_product_json = [];
        
        $.each(cart_product.items,function(k,v){
            var temp_inner_product = {};
            var product_detail = '';
        
            product_detail = getProductFromHandle(v.handle);
            original_price = product_detail.product['variants'][0]['compare_at_price'];
            brand_name = v.vendor;
            setCategory();
            var offer_Price = v.original_price/100;

            if (original_price == '') {
                original_price = offer_Price;
            }

            temp_inner_product['Category'] = category_name;
            temp_inner_product['SubCategory'] = sub_category_name;
            temp_inner_product['Brand'] = brand_name;
            temp_inner_product['Product Name'] = v.title;
            temp_inner_product['sku'] = v.sku;
            temp_inner_product['Original amount'] = original_price;
            temp_inner_product['Offer amount'] = offer_Price;
            temp_inner_product['Quantity'] = v.quantity;
            temp_product_json.push(temp_inner_product);
        });
        temp_product_json['Total amount'] = cart_product.total_price/100;
        return temp_product_json;
    };
    // Function for Collecting Compare Price
    function get_compare_price(handle){
        console.log("Handle : Function",handle);
        var product_URL = "https://itcstore.online/products/" + handle +".json";
        $.getJSON(product_URL, function (result) {
            console.log(result.product['variants'][0].compare_at_price,'value.compare_at_price')
            return result.product['variants'][0].compare_at_price;
        });
    }
    $('document.body').on('click','.btn-remove',function(){
        console.log('cart remove click');
    });

    //knowmored
    $('body').on('click','.pincode-popup-check,#pincode-popup-check',function(){
        var current_obj = $(this);
        var product_handle = '';
        console.log(product_handle,'product_handle one')
        if (product_handle == '') {
            var get_product_id = current_obj.parents('.grid-item').find('.product-title').attr('href');

            if (get_product_id == undefined) {
                get_product_id = current_obj.attr('data-handle');
            }
            
            product_handle = get_product_id.split('/');
            product_handle = product_handle[product_handle.length-1];
        }

        if (product_handle == '') {
            var get_product_id_array = current_obj.parents('.grid-item').find('.product-title');
            var get_product_id = '';

            if (get_product_id_array.length > 1) {
                $.each(get_product_id_array,function(k,v){
                    get_product_id = $(v).attr('href');
                });
            }

            product_handle = get_product_id.split('/');
            product_handle = product_handle[product_handle.length-2];
        }
        if (product_handle != '') {
            var res = getProductFromHandle(product_handle);
            console.log(res,'resss');
            setValueDataLayer('ITCStore_KnowMore',res);
        }
    });

    $('body').on('click','.st-add-item',function(){
        var product_obj = $(this);

        var get_product_id = product_obj.attr('data-handle');
        
        var product_handle = get_product_id.split('/');
        product_handle = product_handle[product_handle.length-1];

        if (product_handle != '') {
            var cart_quantity = 0;
            var find_form = product_obj.parents('form').find('input[name=quantity]');
            
            var res = getProductFromHandle(product_handle);
            setValueDataLayer('ITCStore_AddToCart',res,true,1);
        }
    });
    $('body').on('click','.update_cart_quantity',function(){
        var product_obj = $(this);

        var product_handle = product_obj.attr('data-handle');
        var type = product_obj.attr('data-button-value');
        if(product_handle != undefined && product_handle != ''){
        product_handle = product_handle.split('/');
        product_handle = product_handle[product_handle.length-1];
            var cart_quantity = $("input[name=quantity]").val();
            console.log(product_handle,cart_quantity,'cart_quantitycart_quantity')
            var find_form = product_obj.parents('form').find('input[name=quantity]');

            $.each(find_form,function(k,v){
                cart_quantity = parseInt($(v).val());
            });
            var res = getProductFromHandle(product_handle);
            if (type == 'inc') {
                setValueDataLayer('ITCStore_AddToCart',res,true,1);
            }else{
                setValueDataLayer('ITCStore_RemoveFromCart',res,true,1);
            }
        }
    });
    // add_to_cart DataLayer Functions
    $('body').on('click','.add-to-cart-btn,#product-add-to-cart',function(){
        var product_obj = $(this);

        var get_product_id = product_obj.parents('.grid-item').find('.product-title').attr('href');
        
        if (get_product_id == undefined) {
            get_product_id = product_obj.attr('data-handle');
        }
        
        var product_handle = get_product_id.split('/');
        product_handle = product_handle[product_handle.length-1];

        if (product_handle != '') {
            var cart_quantity = $("input[name=quantity]").val();
            console.log(product_handle,cart_quantity,'cart_quantitycart_quantity')
            var find_form = product_obj.parents('form').find('input[name=quantity]');

            $.each(find_form,function(k,v){
                cart_quantity = parseInt($(v).val());
            });
            var res = getProductFromHandle(product_handle);
            setValueDataLayer('ITCStore_AddToCart',res,true,cart_quantity);
        }

        // console.log("Data Layer: ", dataLayer);
    });

    //subscription add cart
    $('#subscriptions').on('click','.action',function(){
        var action_obj = $(this);
        var get_product_url = action_obj.parents('.product-item').find('.product-title').attr('href');

        var product_handle = get_product_url.split('/');
        product_handle = product_handle[product_handle.length-1];

        var res = getProductFromHandle(product_handle);
        setValueDataLayer('ITCStore_AddToSubscriptionCart',res,false);
    });

    //remove product from subscription
    $('#subscriptions').on('click','.remove-product',function(){
        var action_obj = $(this);
        var product_id = action_obj.attr('data-product_id');

        var get_product_url = $('#product-'+product_id).find('.product-title').attr('href');

        var product_handle = get_product_url.split('/');
        product_handle = product_handle[product_handle.length-1];

        var res = getProductFromHandle(product_handle);
       setValueDataLayer('ITCStore_RemoveFromSubscriptionCart',res,false); 
    });

    //facebook share
    $('body').on('click','.at-svc-facebook',function(){
        setSocialDataLayer('ITCStore_FacebookShare')
    });
    //Twitter share
    $('body').on('click','.at-svc-twitter',function(){
        setSocialDataLayer('ITCStore_TwitterShare')
    });
    //Pinterest share
    $('body').on('click','.at-svc-pinterest_share',function(){
        setSocialDataLayer('ITCStore_PinterestShare')
    });
    //set value to datalayer of social
    function setSocialDataLayer(event_name){

   //     product_type = "";            // Product Type
     //   product_brand = "";         // Product Vendor
      //  product_name = "";            // Product Name
        //product_sku = "";       // Product Sku
       // product_price = "";   // Product Price
       // product_compare_price = "";

        if (product_compare_price == "" || product_compare_price == 0) {
            product_compare_price = product_price;
        }

        var discount = discount_calulcation(product_compare_price, product_price);
        digitalData.push({
            page: {
                Event           :   event_name,
            },
            product: {
                ProductName     :   product_name,
                Sku             :   product_sku,
                Original_Price  :   product_compare_price,
                Offer_Price     :   product_price,
                Discount        :   discount,
                BrandName       :   brand_name,
                Category        :   category_name,
                SubCategory     :   sub_category_name,
                BrandName       :   brand_name
            }
        });
    }
    //set value to datalayer
    setValueDataLayer = function(event_name,res,cart_quantity_status,cart_quantity = 1){
        var product_response = res.product;
        var product_variant = product_response.variants[0]
        var main_price = product_variant['price'];
        var compare_price = product_variant['compare_at_price'];
        if (compare_price == "" || compare_price == 0) {
            compare_price = main_price;
        }
        var product_sku_new = product_variant['sku'];

        // if (cart_quantity_status == true) {
        //     var cart_main_json = getCartProduct();

        //     $.each(cart_main_json.items,function(k,v){
        //         if (v.sku == product_sku_new) {
        //             cart_quantity = parseInt(v.quantity) + cart_quantity;
        //         }
        //     });
        // }

        product_name            = product_response['title'];
        product_sku             = product_sku_new;
        product_compare_price   = compare_price;
        product_price           = main_price;
        brand_name              = product_response.vendor;
        cart_quantity           = cart_quantity;

        if (product_compare_price == "" || product_compare_price == 0) {
            product_compare_price = product_price;
        }

        setCategory();
        
        var discount = discount_calulcation(product_compare_price, product_price);
        dataLayer.push({
            page: {
                Event           :   event_name,
            },
            product: {
                ProductName     :   product_name,
                Sku             :   product_sku,
                Original_Price  :   product_compare_price,
                Offer_Price     :   product_price,
                Discount        :   discount,
                Category        :   category_name,
                SubCategory     :   sub_category_name,
                BrandName       :   brand_name,
                Quantity        :   cart_quantity
            }
        });
        digitalData.push({
            page: {
                Event           :   event_name,
            },
            product: {
                ProductName     :   product_name,
                Sku             :   product_sku,
                Original_Price  :   product_compare_price,
                Offer_Price     :   product_price,
                Discount        :   discount,
                Category        :   category_name,
                SubCategory     :   sub_category_name,
                BrandName       :   brand_name,
                Quantity        :   cart_quantity
            }
        });
    }
    //set category
    function setCategory(){
        $.each(category_hierarchy, function(key, value){
            if (value.brand_name.toUpperCase() === brand_name.toUpperCase()){
                category_name = value.category;
                sub_category_name = value.sub_category;
                brand_name = brand_name;
            }
        });
    }

    // Discount Value and % to find from Products Price and Compare Price
    function discount_calulcation(product_compare_price, product_price){
        var discount = 0;
        product_compare_price = parseInt(product_compare_price);
        product_price = parseInt(product_price);
        if (product_compare_price > product_price){
            discount = (parseInt(product_compare_price) - parseInt(product_price)) * 100 / parseInt(product_compare_price);
            discount = discount.toFixed(2);
        }
        
        return discount;
    }
});
//remove cart
function removeCartData(remove_cart) {
    var get_product_obj = $(remove_cart);
    var find_product_url = get_product_obj.parents('li').find('a').eq(0).attr('href');
    find_product_url = find_product_url.split('?')[0];
    find_product_url = find_product_url.split('/')[2];
    var product_data = getProductFromHandle(find_product_url);
    var quantity = get_product_obj.parents('li').find('.minus').attr('data-current-value');
    
    setValueDataLayer('ITCStore_RemoveFromCart',product_data,false,quantity)
};
//get subsctiption
